export default __webpack_public_path__ + "static/media/thermometer-half.32847113.svg";